import {inject, Pipe, PipeTransform} from '@angular/core';
import {LobbyStore} from "../../store/lobby.store";
import {Team} from "../../../backend/model/team.model";
import {TranslateService} from "@ngx-translate/core";
import {getTeamName} from "../util/text.util";

@Pipe({
  name: 'teamName',
  standalone: true
})
export class TeamNamePipe implements PipeTransform {

  readonly lobbyStore = inject(LobbyStore);

  readonly translate = inject(TranslateService);

  transform(team: Team | Team[], dontUseYou = false): string {
    return getTeamName(team, {
      translate: this.translate,
      lobbyType: this.lobbyStore.type(),
      ownTeamId: this.lobbyStore.ownTeam()?.id,
      dontUseYou
    })
  }
}
